import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Hotkey } from 'ui-components/components/hotkey';
import { OperatingSystemService } from 'ui-components/services/operating-system-service';

import { messages } from '../messages';

type DeleteWidgetHotkeyProps = {
  onDelete: () => void;
  disabled?: boolean;
};

export const DeleteWidgetHotkey = ({ onDelete, disabled = false }: DeleteWidgetHotkeyProps) => {
  const intl = useIntl();
  const ctrlOrCmd = OperatingSystemService.isMac() ? 'Cmd' : 'Ctrl';

  const hotkeyMetadata = useMemo(
    () => ({
      doNotTrack: true,
      handler: onDelete,
      hotkey: [
        {
          key: 'd',
          hasCtrlEquivalent: true,
          hasModifier: true,
        },
      ],
      isCustomPreset: true,
      name: `${ctrlOrCmd} + D`,
      presetName: intl.formatMessage(messages.deleteWidgetHotkey),
    }),
    [intl, onDelete, ctrlOrCmd],
  );

  if (disabled) {
    return null;
  }

  return <Hotkey hotkey={hotkeyMetadata} />;
};
